import { render, staticRenderFns } from "./SingleItem.vue?vue&type=template&id=d8532be8"
import script from "./SingleItem.vue?vue&type=script&lang=js"
export * from "./SingleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8532be8')) {
      api.createRecord('d8532be8', component.options)
    } else {
      api.reload('d8532be8', component.options)
    }
    module.hot.accept("./SingleItem.vue?vue&type=template&id=d8532be8", function () {
      api.rerender('d8532be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/SingleItem.vue"
export default component.exports